import React, { PropTypes } from 'react';

const Warning = (props) => {
    const { buttonPrimary, buttonSecondary, modal } = props;

    return (
        <div>
            <header className="modal-header">
                <h3> { modal.header } </h3>
            </header>
            <div className="modal-body">
                <p> { modal.msg } </p>
            </div>
            <div className="modal-buttons">
                {(buttonSecondary) ? <a className="modal-buttons__button cancel-button" onClick={buttonSecondary}>Cancel</a> : null}
                <button className="modal-buttons__button confirm-button" onClick={buttonPrimary}>OK</button>
            </div>
        </div>
    );
};

Warning.propTypes = {
    buttonPrimary: PropTypes.func.isRequired,
    buttonSecondary: PropTypes.func,
    modal: PropTypes.object.isRequired,
};

export default Warning;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Modals/Warning.jsx